import script from "./updateList.vue?vue&type=script&setup=true&name=updateList&lang=js"
export * from "./updateList.vue?vue&type=script&setup=true&name=updateList&lang=js"

const __exports__ = script;

export default __exports__